import React from "react";
import { PanelPropertiesCard } from "@sonder/ui/source/styled/components/PanelPropertiesCard";
import { TaskData } from "core/queries/GetTask";
import { ExternalLink } from "tasks/components/TaskPanel/ExternalLink";

export const SALESFORCE_INFO = {
  options: [
    {
      label: "Salesforce link",
      path: "booking.account.salesforceAssociation.salesforceUrl",
      transform: (value: string, data: TaskData) => (
        <ExternalLink
          href={value}
          segmentOnClickEvent={{
            eventName: "task_panel",
            action: "click",
            element: "salesforce_link",
            props: { taskId: data.id },
          }}
        />
      ),
    },
  ],
};

export const SalesforceCard = ({ task }: { task: TaskData }) => (
  <PanelPropertiesCard data={task} options={SALESFORCE_INFO.options} />
);
